export default __webpack_public_path__ + "static/media/stats-received-recognition.d3fc569b.svg";